import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import { isConfigFlagEnabled } from '../config';
import { FireIcon } from '../icons/fireIcon';
import { isLocalhostEnvironment } from '../utils/utils';
import { ALL_POKER_VARIANT_PROPERTIES } from './pokerVariantTypes';
export const ALL_CREATE_ROOM_TYPE_PROPERTIES = {
    regular: {
        name: 'Regular Game',
        hasBuyinRangeControl: true,
        hasNumSeatsControl: true,
        hasBlindsControl: true
    },
    stt: {
        name: 'Single Table Tournament',
        svgIconComponent: EmojiEventsRoundedIcon,
        hasNumSeatsControl: true
    },
    mtt: {
        name: 'Multi Table Tournament',
        svgIconComponent: EmojiEventsRoundedIcon,
        hasNumSeatsControl: isLocalhostEnvironment() ? true : undefined
    },
    'all-insanity': {
        name: 'All-Insanity',
        svgIconComponent: FireIcon,
        hasBuyinRangeControl: true,
        hasNumSeatsControl: true,
        isPowerPlayerOnly: true,
        validator: ({ variantId }) => isConfigFlagEnabled('allInGames') && ALL_POKER_VARIANT_PROPERTIES.holdEm.variantId == variantId
    }
};
export const ALL_BLINDS_LEVELS = ['low', 'normal', 'high']; // in order with respect to indexes present in inbounds
export const BLINDS_LEVELS_LABELS = {
    low: 'Low (2%)',
    normal: 'Normal (4%)',
    high: 'High (6%)'
};
export const ALL_CURRENCIES = ['chips', 'jacks']; // in order with respect to indexes present in inbounds
export const CURRENCY_NAMES = {
    chips: 'Chips',
    jacks: 'Jacks'
};
export function isCurrency(val) {
    return typeof val === 'string' && ALL_CURRENCIES.includes(val);
}
export const ALL_NUM_SEATS = [4, 5, 6, 7, 8, 9, 10, 11];
export const ALL_NUM_MTT_SEATS = [2, 3, 4, 5];
export const ALL_BUY_IN_RANGES = ['none', 'wide', 'vast'];
export const ALL_BUY_IN_RANGE_MULTIPLIERS = {
    none: [1, 1],
    wide: [0.5, 2],
    vast: [0.2, 5]
};
export const BUY_IN_RANGE_LABELS = {
    none: 'None',
    wide: `Wide (${ALL_BUY_IN_RANGE_MULTIPLIERS.wide[1] / ALL_BUY_IN_RANGE_MULTIPLIERS.wide[0]}x)`,
    vast: `Vast (${ALL_BUY_IN_RANGE_MULTIPLIERS.vast[1] / ALL_BUY_IN_RANGE_MULTIPLIERS.vast[0]}x)`
};
